// Libraries
import React, { useState } from 'react';

const UserContext = React.createContext();

const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    name: '',
    company: '',
    operation: '',
    position: '',
    email: '',
    tnc: false
  });

  return <UserContext.Provider value={{ user, setUser }}>{children}</UserContext.Provider>;
};

export default UserContext;
export { UserProvider };
